import { useForm } from "react-hook-form";
import EdTextfield from "../../components/forms/EdTextfield";
import { TERipple } from "tw-elements-react";
import EdocertLogo from "../../assets/edocert-logo.svg";
import ExagonLogo from "../../assets/exagon-logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { useLogin } from "./hooks/useAuth";

interface LoginFormInputs {
  email: string;
  password: string;
}

export default function LoginPage() {
  const navigate = useNavigate();
  const isDev = import.meta.env.DEV;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormInputs>({
    mode: "onSubmit",
    defaultValues: isDev ? {
      email: "a.visconti@exagonplus.com",
      password: "111111",
    } : undefined,
  });

  const { mutate: login, isPending } = useLogin();

  const onSubmit = (data: LoginFormInputs) => {
    console.log("Login attempt:", data);
    login(data, {
      onSuccess: (response) => {
        console.log("Login success:", response);
        navigate("/dashboard");
      },
      onError: (error) => {
        console.error("Login error:", error);
      },
    });
  };

  return (
    <div className="flex min-h-screen items-start pt-[80px] justify-center bg-gray-100 w-screen relative">
      <div className="absolute top-0 z-0 w-full h-1/2 bg-red-800"></div>
      <div className="w-full max-w-[658px] max-h-[502px] min-h-[502px] box-border z-30">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          className="bg-white shadow-md rounded-lg px-8 md:px-[100px] mx-4 md:mx-0 pb-14 pt-10"
        >
          <div className="flex justify-center mb-8">
            <img src={EdocertLogo} className="w-[260px]" />
          </div>

          <div className="mb-4">
            <EdTextfield
              label="Inserisci email"
              type="text"
              id="email"
              placeholder="Inserisci email o username"
              register={register("email", {
                required: "Campo obbligatorio",
              })}
              error={errors.email && errors.email.message}
            />
          </div>

          <div className="mb-4">
            <EdTextfield
              label="Password"
              type="password"
              id="password"
              placeholder="Inserisci password"
              register={register("password", {
                required: "Campo obbligatorio",
                minLength: {
                  value: 6,
                  message: "La password deve essere di almeno 6 caratteri",
                },
              })}
              error={errors.password && errors.password.message}
            />
          </div>

          <div className="flex flex-col gap-4">
            <TERipple rippleColor="light" className="w-full">
              <button
                type="submit"
                disabled={isPending}
                className="w-full rounded bg-red-700 px-6 pb-2.5 pt-3 text-xs font-medium uppercase leading-normal text-white transition duration-150 ease-in-out hover:bg-red-800 disabled:opacity-50"
              >
                {isPending ? "Caricamento..." : "Accedi"}
              </button>
            </TERipple>
          </div>

          <div className="flex justify-center items-center mt-8 mb-6 w-full text-center">
            <div className="flex w-full text-sm text-center">
              <Link
                to="/forgot-password"
                className="w-full font-medium text-center text-edPrimaryColor-500 hover:text-red-800"
              >
                Hai dimenticato la password?
              </Link>
            </div>
          </div>

          <div className="flex justify-center">
            <img src={ExagonLogo} className="" />
          </div>
        </form>
      </div>
    </div>
  );
}
